import {
  createGetLoginUserFromStores,
  getLsqIsUserTypeFreeSnapshot,
  mapConnectivityToLsqNetworkType,
  SqsEvents,
} from "@repo/analytics";
import { useAuthStore } from "../store/useAuthStore";
import { getCurrentProgram } from "./setupApi";

const LSQ_MWEB_MAX_VIEWPORT_WIDTH = 1025;

export { setLsqIsUserTypeFree } from "@repo/analytics";

function getDefaultProfile() {
  const profiles =
    useAuthStore.getState().profilesData?.unified_account_details?.profiles ??
    [];
  return profiles.find((p) => p.is_default_profile) ?? profiles[0];
}

export function initLsqSqsEvents(): void {
  SqsEvents.init({
    isDebug: import.meta.env.DEV,
    lsqManagementClientName: "lsqManagement",
    lsqServiceClientName: "lsqService",
    getModuleEnv: () =>
      import.meta.env.BRANCH || import.meta.env.MODE || undefined,
    getOneGeniusApiBaseUrl: () => import.meta.env.VITE_ONE_GENIUS || undefined,
    getDeviceModel: () =>
      typeof navigator !== "undefined" ? navigator.userAgent : "",
    getLsqServicePlatform: () => "web",
    isMobileWebViewport: () =>
      typeof window !== "undefined" &&
      window.innerWidth <= LSQ_MWEB_MAX_VIEWPORT_WIDTH,
    defaultPlatform: "Web",
    getNetworkType: () => {
      try {
        if (typeof navigator === "undefined") return null;
        if (!navigator.onLine) return null;
        const rawType =
          (navigator as Navigator & { connection?: { type?: string } })
            .connection?.type ?? "";
        const mapped = mapConnectivityToLsqNetworkType(true, rawType);
        if (mapped) return mapped;
        return "Wi-Fi";
      } catch {
        return null;
      }
    },
    getLoginUser: createGetLoginUserFromStores({
      getUnifiedAccountDetails: () =>
        useAuthStore.getState().profilesData?.unified_account_details,
      getDefaultProfile,
      getCurrentProgram,
      getStudentLoginId: () =>
        getDefaultProfile()?.admission_id as string | null | undefined,
      profile: () => ({
        vertical_id: getDefaultProfile()?.vertical_id as
          | number
          | null
          | undefined,
        admission_id: getDefaultProfile()?.admission_id as
          | string
          | null
          | undefined,
        exams: getDefaultProfile()?.exams as
          | { examId: number; name: string }[]
          | null,
      }),
    }),
    getIsUserTypeFree: () => getLsqIsUserTypeFreeSnapshot(),
    getIsPackageAmountMoreThenThousand: () => false,
    getHasTriggerLsqForSubscription: () => false,
  });
}
